import { FC, PropsWithChildren } from "react";
import clsx from "clsx";
import { RowProps } from "@/components/row/types";
import styles from "./styles.scss";

export const Row: FC<PropsWithChildren<RowProps>> = ({
  children,
  size,
  className,
  ...props
}) => (
  <div className={clsx(size && styles[size], className)} {...props}>
    {children}
  </div>
);
